import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';
import WithAjax from 'static/script/app/data/with-ajax';

function WishListService() {

    this._addItemToWishList = function (evt, payload) {
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }

        this._post({
            url: '/shopping/wishlist/add',
            data: payload,
            success: 'data:item:wish-list-item-added'
        });
    };

    this._removeItemFromWishList = function (evt, payload) {
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }

        this._post({
            url: '/shopping/wishlist/remove',
            data: payload,
            success: 'data:item:wish-list-item-removed'
        });
    };

    this._removeItemsFromWishList = function (evt, payload) {
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }

        this._post({
            url: '/my/wish-list/remove',
            data: payload,
            success: 'data:item:wish-list-item-removed'
        });
    };

    this.after('initialize', function () {
        this.on(document, 'ui:item:on-add-to-wish-list', this._addItemToWishList);
        this.on(document, 'ui:item:on-remove-from-wish-list', this._removeItemFromWishList);
        this.on(document, 'ui:item:on-remove-multiple-from-wish-list', this._removeItemsFromWishList);
    });
}

module.exports = defineComponent.component(WishListService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/wish-list-service.js